import React, {useContext} from 'react';

import {WidthItem} from 'src/components/width-item';
import {useDateTime} from 'src/hooks/date-time/useDateTime';
import {mapDateFormat} from 'src/utils/mapDateFormat';

import {FormattedDate, Integer} from '@pb/kit-component-formatters';
import {Group} from '@pb/kit-component-group';
import Icon, {Icons} from '@pb/kit-component-icon';
import Loading from '@pb/kit-component-loading';
import {LocaleContext} from '@pb/kit-context-locale';


import type {UserTotalLimit} from 'src/openapi/admin/models/UserTotalLimit';
import type {ServerResponse} from 'src/typedef';

type Props = {
    limit: ServerResponse<UserTotalLimit> | null,
};

export const LimitDetails = ({limit}: Props) => {
    const {locale} = useContext(LocaleContext);
    const {getLocalDate} = useDateTime();

    if (!limit) {
        return (
            <Group alignItems="center">
                <Loading type="ICON"/>
                loading
            </Group>
        );
    }

    const data = limit.data;

    if (!data) {
        return <div/>;
    }

    return (
        <WidthItem width="100%">
            <Group justify="space-between">
                <Group direction="v" gap="xs">
                    {(data.temporaryValue || data.temporaryValue === 0) ? (
                        <Group gap="xs" alignItems="center" justify="start">
                            <Icon type={Icons.CALENDAR}/>
                            <span>Temporary:</span>
                            <b>{data.temporaryUnlimited
                                ? 'Unlimited'
                                : Integer.format(data.temporaryValue, locale)}
                            </b>
                            <span>(until {FormattedDate.format({
                                value: getLocalDate(data.temporaryExpiration || ''),
                                format: mapDateFormat(locale.dateFormat, 'WORD'),
                            })})
                            </span>
                        </Group>
                    ) : null}
                    {(data.overrideValue || data.overrideValue === 0) ? (
                        <Group gap="xs" alignItems="center" justify="start">
                            <Icon type={Icons.COGS}/>
                            <span>Custom:</span>
                            <b>{data.overrideUnlimited
                                ? 'Unlimited'
                                : Integer.format(data.overrideValue, locale)}
                            </b>
                        </Group>
                    ) : null}
                    <div style={{paddingLeft: 16}}>
                        <Group gap="xs" justify="start">
                            <span>Default:</span>
                            <b>{data.defaultUnlimited
                                ? 'Unlimited'
                                : Integer.format(data.defaultValue, locale)}
                            </b>
                        </Group>
                    </div>
                </Group>
            </Group>
        </WidthItem>
    );
};
